import React, { useEffect } from 'react';
import { ONBOARDING_URL } from '../shared/constants';

const Onboarding = () => {
    useEffect(() => window.location.replace(ONBOARDING_URL), [])
    return <h1>Onboarding...</h1>;
}

export default Onboarding